<template>
  <div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-data-table
          class="text-center"
          :apiMode="true"
          :apiUrl="apiUrl"
          :httpOptions="httpOptions"
          :itemsPerPage="itemsPerPage"
          :defaultPerPage="defaultTablePerPage"
          :queryParams="queryParams"
          :tableFields="tableFields"
          :perPageSelectorShown="false"
          :actions="true"
          :additionalActions="true"
          :filterInputLabel="'Service Name'"
        >
          <template slot="additionalTableControl">
            <vuestic-simple-select
              label="Service Type"
              v-model="service"
              :options="services"
              :optionKey="'ident_code'"
              :name="'serviceName'"
              :clearable="false"
            />
          </template>
        </vuestic-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      service: {
        id: 1,
        ident_code: 'calls'
      },
      tableFields: [
        {
          name: '__sequence',
          dataClass: 'text-light'
        },
        {
          name: 'name',
          title: 'Service Name'
        },
        {
          name: 'code',
          title: 'Service Code'
        },
        {
          name: 'rate',
          title: 'Rate'
        },
        {
          name: 'currency',
          title: 'Currency'
        }
      ],
      queryParams: {
        sort: 'sort',
        page: 'page',
        perPage: 'per_page'
      },
      itemsPerPage: [
        {
          value: 10
        },
        {
          value: 25
        },
        {
          value: 50
        }
      ],
      defaultTablePerPage: 10
    }
  },
  computed: {
    ...mapGetters(['tenantID', 'services']),
    apiUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}billing/api/v1/rates/data?tenant_uuid=${this.tenantID}&servicesId=${this.serviceID}`
    },
    serviceID() {
      return this.service.id ? this.service.id : 1
    }
  }
}
</script>
<style lang="scss" scoped>
.vuestic-simple-select {
  min-width: 18rem;
}
</style>
